module.exports = __webpack_public_path__ + "officialStatic/img/partnerBg.4fb63ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/partnerBg.jpg
// module id = swel
// module chunks = 0